const WorkData = [
    {name: "LAPIN", yearDisplay: "2019-2023", year: "2023", category: "Video Game", comment: "Environmental art",
        backgroundImage: "Lapin.webp", link: "https://store.steampowered.com/app/1454540/_/"},
    {name: "VANDALISM101", yearDisplay: "2022-", year: "2022", category: "Video Game", comment: "WIP. Solo project",
        backgroundImage: "Vandalism101.webp", link: ""},
    {name: "SOLATERIA", yearDisplay: "2023-2024", year: "2024", category: "Video Game", comment: "Environmental art",
        backgroundImage: "Solateria.webp", link: ""},

    {name: "무연고장례", yearDisplay: "2019-2023", year: "2023", category: "Comics", comment: "Comics compilation",
        backgroundImage: "Necrocomiche.webp", link: "https://www.postype.com/@cata-dioptric/series/1121678"},
    {name: "PPPMPD", yearDisplay: "2024-", year: "2025", category: "Comics", comment: "WIP. Comic series.",
        backgroundImage: "PPPMPD.webp", link: "https://www.postype.com/@cata-dioptric/series/1368580"},

    {name: "아날로그 블루", yearDisplay: "2021", year: "2021", category: "Graphic Design", comment: "Cover design/MD design",
        backgroundImage: "Analog_Blue.webp", link: "https://www.yes24.com/Product/Goods/108737303"},
    {name: "젊음 반품", yearDisplay: "2024", year: "2024", category: "Graphic Design", comment: "Cover design",
        backgroundImage: "Youth_for_Sale.webp", link: "https://www.yes24.com/product/goods/141195750"},
    {name: "만화공업단지", yearDisplay: "2023-", year: "2023", category: "Graphic Design", comment: "Cover design/Identity design",
        backgroundImage: "CIC.webp", link: "https://x.com/mangongdan"},

    {name: "FROSTBOUND", yearDisplay: "2025", year: "2025", category: "Music", comment: "Original Song",
        backgroundImage: "FROSTBOUND.webp", link: "https://www.youtube.com/watch?v=o7-ZHzmAEMw"},
    {name: "ÉCRITS", yearDisplay: "2024", year: "2024", category: "Music", comment: "Original Song",
        backgroundImage: "Ecrits.webp", link: "https://youtu.be/7zX9JONl5gw"},
    {name: "螺旋ノ唄", yearDisplay: "2024", year: "2024", category: "Music", comment: "Original Song",
        backgroundImage: "Rasenno_Uta.webp", link: "https://youtu.be/zyytkraN-1o"},
    {name: "世世生生", yearDisplay: "2022", year: "2022", category: "Music", comment: "Original Song",
        backgroundImage: "Sezeshojo.webp", link: "https://youtu.be/YGUamPabwz4"},
];
export default WorkData;